import type { JSX } from "react";
import DocsTable_Component from './DocsTable_Component';
import { useAppSelector } from './hooks/reduxHooks';

const DocsTab_Component = (): JSX.Element => {
  const status = useAppSelector((state) => state.resultsSlice.status);

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="h-full w-full pt-2">
      <DocsTable_Component />
    </div>
  );
};

export default DocsTab_Component;
